import axios from 'axios'

const API_BASE_URL = 'http://localhost:13000/api/v1'

export interface Panel {
  id: string
  tenant_id: string
  panel_type: string
  key_or_sn: string
  status: string
  location: string
  description?: string
  specifications?: Record<string, any>
  created_at: string
  updated_at: string
}

export interface CreatePanelRequest {
  panel_type: string
  key_or_sn: string
  status: string
  location: string
  description?: string
  specifications?: Record<string, any>
}

export interface PanelListResponse {
  items: Panel[]
  total: number
  skip: number
  limit: number
}

class PanelsService {
  async listPanels(
    skip: number = 0,
    limit: number = 50,
    filters?: {
      status?: string
      location?: string
      panel_type?: string
    }
  ): Promise<PanelListResponse> {
    try {
      const params = new URLSearchParams()
      params.append('skip', String(skip))
      params.append('limit', String(limit))

      if (filters?.status) {
        params.append('status', filters.status)
      }
      if (filters?.location) {
        params.append('location', filters.location)
      }
      if (filters?.panel_type) {
        params.append('panel_type', filters.panel_type)
      }

      const response = await axios.get(`${API_BASE_URL}/equipment/panels?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error listing panels:', error)
      throw error
    }
  }

  async getPanel(id: string): Promise<Panel> {
    try {
      const response = await axios.get(`${API_BASE_URL}/equipment/panels/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching panel ${id}:`, error)
      throw error
    }
  }

  async createPanel(data: CreatePanelRequest): Promise<Panel> {
    try {
      const response = await axios.post(`${API_BASE_URL}/equipment/panels`, data)
      return response.data
    } catch (error) {
      console.error('Error creating panel:', error)
      throw error
    }
  }

  async updatePanel(id: string, data: Partial<CreatePanelRequest>): Promise<Panel> {
    try {
      const response = await axios.put(`${API_BASE_URL}/equipment/panels/${id}`, data)
      return response.data
    } catch (error) {
      console.error(`Error updating panel ${id}:`, error)
      throw error
    }
  }

  async deletePanel(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/equipment/panels/${id}`)
    } catch (error) {
      console.error(`Error deleting panel ${id}:`, error)
      throw error
    }
  }
}

export const panelsService = new PanelsService()
